var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-adv-options__cont" },
    [
      _c("setting", {
        attrs: {
          classes: ["alpheios-adv-options__item"],
          data: _vm.uiOptions.items.verboseMode,
        },
        on: { change: _vm.uiOptionChanged },
      }),
      _vm._v(" "),
      _c(
        "fieldset",
        { staticClass: "alpheios-adv-options__cont-wordselect" },
        [
          _c("legend", [
            _vm._v(_vm._s(_vm.l10n.getText("LABEL_FIELDSET_MOUSEMOVE"))),
          ]),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-adv-options__item",
            attrs: { data: _vm.uiOptions.items.mouseMoveDelay },
            on: { change: _vm.uiOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-adv-options__item",
            attrs: { data: _vm.uiOptions.items.mouseMoveAccuracy },
            on: { change: _vm.uiOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-adv-options__item",
            attrs: { data: _vm.uiOptions.items.forceMouseMoveGoogleDocs },
            on: { change: _vm.uiOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-adv-options__item",
            attrs: {
              data: _vm.uiOptions.items.enableMouseMoveLimitedByIdCheck,
            },
            on: { change: _vm.uiOptionChanged },
          }),
          _vm._v(" "),
          _c("setting", {
            staticClass: "alpheios-adv-options__item",
            attrs: { data: _vm.uiOptions.items.mouseMoveLimitedById },
            on: { change: _vm.uiOptionChanged },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }